export const HandleSelectedPayment = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedPayment = event.target.selectedOptions[0].text.toLowerCase();
    const selectedPaymentId = event.target.value;

    if (selectedPayment === "cartão de crédito") {
        return {
            id: selectedPaymentId,
            name: 'credit-card'
        }
    } else if (selectedPayment === "pag. combinado") {
        return {
            id: selectedPaymentId,
            name: 'combined-payment'
        }
    } else if (selectedPayment === "crediário da loja") {
        return {
            id: selectedPaymentId,
            name: 'payment-credit'
        }
    }

    return {
        id: null,
        name: ''
    };
}